import { Modal } from 'antd';
import './index.scss';

export default (props) => (
  <Modal {...props} className={`modal-component ${props.className || ''}`}>
    {props.children}
  </Modal>
);
